'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _templateObject = _taggedTemplateLiteral(['from{transform:rotate(0deg);}to{transform:rotate(360deg);}'], ['from{transform:rotate(0deg);}to{transform:rotate(360deg);}']);

var _styledComponents = require('styled-components');

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var rotate360 = (0, _styledComponents.keyframes)(_templateObject);

exports.default = rotate360;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ../mcs-lite-ui/lib/Spin/rotate360.js
// module id = 515
// module chunks = 4